<template>
  <v-row class="customer-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0">
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="categoryLoading"
        type="table-tbody"
      >
      </v-skeleton-loader>
      <v-simple-table v-else class="simple-table" height="67vh">
        <template v-slot:default>
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <td style="width: 100px !important">
                <v-checkbox
                  v-model="selectedAll"
                  class="hide-margin py-0 my-0"
                  color="cyan"
                  dense
                  hide-details
                ></v-checkbox>
              </td>

              <td class="font-size-13 text-uppercase font-weight-500">
                Category
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Checklist
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Status
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Action
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!rowData || rowData.length === 0">
              <td colspan="5" class="text-center font-italic">
                No categories exist
              </td>
            </tr>
            <tr
              v-for="(row, index) in rowData"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
              v-else
            >
              <td style="width: 60px !important">
                <v-checkbox
                  v-model="selectedRows"
                  class="hide-margin"
                  color="cyan"
                  dense
                  hide-details
                  v-bind:value="row.id"
                ></v-checkbox>
              </td>

              <td class="font-size-14 font-weight-500 text-capitalize">
                {{ row?.category_name || "—" }}
              </td>
              <td class="font-size-14 font-weight-500">
                {{ row?.checklist_name || "—" }}
              </td>
              <td>
                <v-switch
                  v-model="row.activated"
                  inset
                  dense
                  color="green"
                  :true-value="'1'"
                  :false-value="'0'"
                  @change="toggleActivated(row)"
                ></v-switch>
              </td>

              <td>
                <v-btn icon small color="red" @click="deleteCategory(row)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter
        :data-loading="categoryLoading"
        :current-page="page"
        :total-pages="totalPages"
        :showing-from="showingFrom"
        :showing-to="showingTo"
        :total-rows="totalItems"
      />
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { GET, PATCH, DELETE } from "@/core/services/store/request.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import ListingFooter from "@/view/pages/partials/Listing-Footer";

export default {
  name: "contact-persons",
  title: "Customer",
  mixins: [CommonMixin],
  props: {
    customer: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 0,

      categoryLoading: false,
    };
  },
  components: {
    ListingFooter,
  },
  watch: {
    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
    // "customer.categories": {
    //   deep: true,
    //   immediate: true,
    //   handler() {
    //     this.assignData();
    //   },
    // },
  },
  methods: {
    refreshData() {
      this.getCategoryChecklist();
    },
    getCategoryChecklist() {
      const _this = this;

      _this.categoryLoading = true;

      _this.$store
        .dispatch(GET, {
          url: `customer/${_this.customer.id}/category-checklist?page=${_this.page}&per_page=${_this.itemsPerPage}`,
        })
        .then(({ data }) => {
          _this.rowData = data.data || [];
          _this.totalItems = Number(data.total || 0);
          _this.totalPages = Number(data.last_page || 0);
          _this.page = Number(data.current_page || 1);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.categoryLoading = false;
        });
    },

    toggleActivated(row) {
      const status = Number(row.activated);
      this.$store
        .dispatch(PATCH, {
          url: `customer/checklist-category/${row.id}/status`,
          data: { status },
        })
        .then(() => {
          this.getCategoryChecklist();
        })
        .catch((error) => {
          this.logError(error);
        });
    },

    deleteCategory(row) {
      const _this = this;

      _this.$store
        .dispatch(DELETE, {
          url: `customer/checklist-category/${row.id}`,
        })
        .then(() => {
          _this.getCategoryChecklist();
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    // assignData() {
    //   const _this = this;

    //   if (_this.customer && _this.customer.categories) {
    //     _this.rowData = [..._this.customer.categories];
    //   } else {
    //     _this.rowData = [];
    //   }
    // },

    activeInactive(data) {
      if (_this.customer.activated == 0) {
        return false;
      }
      if (data.default == 1) {
        ErrorEventBus.$emit(
          "update:error",
          "The Primary Contact Person can’t be In-Active."
        );
        return false;
      }

      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-person/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {});
    },
  },

  mounted() {
    const _this = this;
    _this.getCategoryChecklist();
    _this.$root.$on("clearSelection", () => {
      _this.selectedRows = [];
    });
    PaginationEventBus.$on("update:pagination", (page) => {
      _this.page = Number(page);
      _this.getCategoryChecklist();
    });
  },

  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  computed: {
    showingFrom() {
      return this.rowData.length > 0
        ? (this.page - 1) * this.itemsPerPage + 1
        : 0;
    },

    showingTo() {
      return this.rowData.length > 0
        ? Math.min(this.page * this.itemsPerPage, this.totalItems)
        : 0;
    },
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.rowData.length) {
          for (let i = this.rowData.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      },
      get() {
        let totalItems = this.rowData.length;
        return totalItems > 0 ? this.selectedRows.length === totalItems : false;
      },
    },
  },
};
</script>
